import { memo } from 'react';
import { Handle, Position } from 'react-flow-renderer';
import { RiBriefcaseLine } from 'react-icons/ri';

const DepartmentNode = ({ data }) => (
    <div className="node department">
        <RiBriefcaseLine size={30} color="#ffffff" className="mb-2" />
        <div>{data.label}</div>

        <Handle type="target" position={Position.Top} />
        <Handle type="source" position={Position.Bottom} />
    </div>
);

export default memo(DepartmentNode);
